import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    convertStartEndDatesForFile,
    toCurrency,
} from '../shared/functions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from "material-ui/FlatButton";
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/communication/location-on';

/**
 * Class for displaying Summary of total Combined Sales in a single table
 *
 */
class CombinedSalesReportSummaryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Day', key: 'day'},
                {label: 'Sales', key: 'totalSales'},
                {label: 'Returns', key: 'totalReturns'},
                {label: 'Adj. Sales', key: 'totalNet'},
                {label: 'Gross', key: 'salesGross'},
                {label: 'Tax', key: 'salesTax'},
                {label: 'Net', key: 'salesNet'},
                {label: 'Returns', key: 'returnSubtotal'},
                {label: 'Adj. Net', key: 'salesAdjusted'},
                {label: 'Average Sale', key: 'salesAverage'}
            ],
            message: null
        };
        this.handleExportClick = this.handleExportClick.bind(this);
    }

    componentWillMount() {
        this.processData(this.props.listData);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.listData !== this.props.listData) {
            this.setState({
                summaryList: []
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listData !== this.props.listData) {
            this.processData(this.props.listData);
        }
    }

    /* Data Processing ------------------------------ */

    /**
     * Arrange data for use by table
     *
     * @param listData
     */
    processData(listData) {

        const emptyCurrency = toCurrency(0);
        let summaryList = [];

        if (listData) {
            let listLength = listData.length;
            for (let i = 0; i < listLength; i++) {
                let item = listData[i];
                const row = {
                    day: (item.day) ? item.day : '',
                    returnSubtotal: (item.returnSubtotal) ? (toCurrency(item.returnSubtotal / 100)) : emptyCurrency,
                    salesAdjusted: (item.salesAdjusted) ? (toCurrency(item.salesAdjusted / 100)) : emptyCurrency,
                    salesAverage: (item.salesAverage) ? (toCurrency(item.salesAverage / 100)) : emptyCurrency,
                    salesGross: (item.salesGross) ? (toCurrency(item.salesGross / 100)) : emptyCurrency,
                    salesNet: (item.salesNet) ? (toCurrency(item.salesNet / 100)) : emptyCurrency,
                    salesTax: (item.salesTax) ? (toCurrency(item.salesTax / 100)) : emptyCurrency,
                    totalNet: (item.totalNet) ? item.totalNet : 0,
                    totalReturns: (item.totalReturns) ? item.totalReturns : 0,
                    totalSales: (item.totalSales) ? item.totalSales : 0,
                };
                summaryList.push(row);
            }
        }

        // Finalize table data
        this.setState({
            summaryList: summaryList,
            summaryTableData: summaryList
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            dataIsFiltered,
            endDate,
            includeDay,
            keyStr,
            startDate,
            system,
            title
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders
        } = this.state;

        const dateString = convertStartEndDatesForFile(startDate, endDate);
        const isFilteredString = (dataIsFiltered) ? '-filtered' : '';

        // ReactTable headers and columns for Table
        const tableColumns = [
            {
                Header: () => (<span># Sales</span>),
                accessor: 'totalSales',
                filterable: false,
                style: tableStyles.right
            },
            {
                Header: () => (<span># Returns</span>),
                accessor: 'totalReturns',
                filterable: false,
                style: tableStyles.right
            },
            {
                Header: () => (<span># Adj. Sales</span>),
                accessor: 'totalNet',
                filterable: false,
                style: tableStyles.right
            },
            {
                Header: () => (<span>Gross</span>),
                accessor: 'salesGross',
                filterable: false,
                style: tableStyles.right,
                width: 120
            },
            {
                Header: () => (<span>Tax</span>),
                accessor: 'salesTax',
                filterable: false,
                style: tableStyles.right,
                width: 120
            },
            {
                Header: () => (<span>Net</span>),
                accessor: 'salesNet',
                filterable: false,
                style: tableStyles.right,
                width: 120
            },
            {
                Header: () => (<span>Returns</span>),
                accessor: 'returnSubtotal',
                filterable: false,
                style: tableStyles.right,
                width: 120
            },
            {
                Header: () => (<span>Adj. Net</span>),
                accessor: 'salesAdjusted',
                filterable: false,
                style: tableStyles.right,
                width: 120
            },
            {
                Header: () => (<span>Average Sale</span>),
                accessor: 'salesAverage',
                filterable: false,
                style: tableStyles.right
            }
        ];
        if (includeDay) {
            tableColumns.unshift({
                Header: () => (<span>Day</span>),
                accessor: 'day',
                filterable: false,
            });
        }

        return (
            <div className="reports-table-container">

                {/* Table Header: Sales Summary */}
                <div className="reports-table-title table-table-header">
                    <div className="btn-report-container table-header-button-container">
                        {/* Export Summary */}
                        <FlatButton
                            primary
                            type="button"
                            label=""
                            style={commonStyles.headerButton}
                        >
                            <ExportIcon style={commonStyles.headerButtonIcon}/>
                            <CSVLink
                                data={summaryTableData}
                                headers={summaryTableHeaders}
                                filename={keyStr + '-' + system + '-' + dateString + isFilteredString + '.csv'}
                                onClick={(e) => this.handleExportClick(e)}
                                target="_blank"
                                style={commonStyles.headerButtonLink}
                            >
                                Export {title}
                            </CSVLink>
                        </FlatButton>
                    </div>
                    <h3 className="table-table-header-title">
                        <TableIcon style={commonStyles.summaryIconSmall}/>
                        <span>{title}</span>
                    </h3>
                </div>

                {/* Table: Summary */}
                <ReactTable
                    key={`table-${keyStr}`}
                    data={summaryList}
                    columns={tableColumns}
                    defaultPageSize={10000}
                    showPagination={false}
                    resizable={false}
                    minRows={1}
                    className="-striped overflow single-row no-print"
                />
            </div>
        )
    }
}

CombinedSalesReportSummaryTable.propTypes = {
    addField: PropTypes.bool,
    dataIsFiltered: PropTypes.bool,
    endDate: PropTypes.string,
    includeDay: PropTypes.bool,
    keyStr: PropTypes.string,
    listData: PropTypes.array,
    startDate: PropTypes.string,
    system: PropTypes.string,
    title: PropTypes.string
};

CombinedSalesReportSummaryTable.defaultProps = {
    addField: true,
    dataIsFiltered: false,
    endDate: null,
    includeDay: false,
    keyStr: 'combined-sales-summary',
    startDate: null,
    title: 'Combined Sales Summary'
};

export default CombinedSalesReportSummaryTable;



// WEBPACK FOOTER //
// ./src/Fuse/components/CombinedSalesReportSummaryTable.js